<template >
    
    <div class="py-4" v-if="loading">
        <b-overlay :show="loading">
        </b-overlay>
    </div>
    <div v-else-if="show" class="d-flex flex-column ">
        <h3>Customer Data  Platform (CDP)</h3>
        <p>Download an Email list of those customers who have consented to subscribe to your restuarant's newsletter to know about your events, promotions, and updates.</p>
        <p>This list is regularly updated.</p>
        <p><span class="font-weight-bold">Note:</span> Use this customer information only for your business newsletter. Do NOT sell, rent, trade, or distribute to the public.</p>
        <b-container fluid class="px-0">
            <b-row class="mb-3 justify-content-center">
            <b-col cols="12" lg="6" xl="3" md="6" class="mb-3 mb-xl-0">
                <b-input-group prepend="From Date">
                <b-form-datepicker
                        locale="en-US"
                        :date-format-options="{'year': 'numeric', 'month': 'long', 'day': 'numeric'}"
                        id="from-example-datepicker" :min="oldestDate" :max="maxDateByToDate" @input="changeFromDate" v-model="filter.FromDate"></b-form-datepicker>
                </b-input-group>
            </b-col>
            <b-col cols="12" lg="6" xl="3" md="6">
                <b-input-group prepend="To Date">
                <b-form-datepicker
                        locale="en-US"
                        :date-format-options="{'year': 'numeric', 'month': 'long', 'day': 'numeric'}"
                        id="to-example-datepicker" :max="maxDate"  :min="minDate" @input="changeToDate" v-model="filter.ToDate"></b-form-datepicker>
                </b-input-group>
            </b-col>
            </b-row>
            <b-row  class="justify-content-center">
      
      <b-col cols="12" lg="6">
        <b-table-simple>
          <b-thead>
            <b-tr style="background-color: #bbbbbb">
              <b-th>Name</b-th>
              <b-th># of Enteries</b-th>
              <b-th></b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr class="bg-white" >
              <b-td>Customer List (csv format)</b-td>
              <b-td>
                <div class="d-flex justify-content-start align-items-center pl-1" v-if="loadingData">
                    <b-overlay :show="loadingData">
                    </b-overlay>
                </div>
                <span v-else>{{numberOfRecords}}</span>
              </b-td>
              <b-td>
                <b-button @click="downloadList" :disabled="numberOfRecords ===0" variant="warning">Download List</b-button>
                
              </b-td>
              
            </b-tr>
            
          </b-tbody>
        </b-table-simple>
      </b-col>
      
    </b-row>
        </b-container>
    </div>

</template>

<script>
    import moment from 'moment'
    import download from 'downloadjs'
    export default {

        name: "overview",
        data(){
            return{
                loading:false,
                loadingData:false,
                show:false,
                filter: {
                    ToDate: null,
                    FromDate: null,
                },
                numberOfRecords:0,
                listLoaded:false
            }
        },
        created(){
            if(localStorage.getItem("ClientTypeID") == "8"){
                //if the client type is 8(kds) don't show the overview page
                this.$router.replace('/todaytickets/index');
            }


            this.loading = true
            //2023-04-02
            const now = new Date()
            //const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())

            let today = now.getFullYear() 
            today += "-"
            today += parseInt(now.getMonth())+1
            today +=  "-" + now.getDate()
            this.filter.ToDate = today
            this.filter.FromDate = today
            this.$api.getRestaurant.GetRestaurantAllowance({RestaurantID:this.$store.state.selectedRestaurantId}).then(res=>{
                this.loading = false
                if(res.results.CDP)
                    this.show = true
                
            }).catch(err=>{
                //
            })
            this.getEmails()
            
        },
        
        computed: {
            maxDate () {
                const now = new Date()
                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                const maxDate = new Date(today)
                return maxDate
            },
            oldestDate () {
                const now = new Date(this.filter.ToDate)
                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                const oldestDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 6 * 30)
                return oldestDate
            },
            maxDateByToDate () {
                const now = new Date(this.filter.ToDate)
                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                const maxDate = new Date(today)
                return maxDate
            },
            minDate () {
              const now = new Date(this.filter.FromDate)
              const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()+1)
              const maxDate = new Date(today)
              return maxDate
            }
        },
        methods: {
            changeFromDate () {
                if (this.allFill())
                    this.getEmails()
                
            },
            changeToDate () {
                if (this.allFill())
                    this.getEmails()
                
            },
            allFill(){
                return this.filter.FromDate && this.filter.ToDate
            },
            getEmails(){
                moment.locale('en');
                this.loadingData = true
                let data ={
                    RestaurantID:this.$store.state.selectedRestaurantId,
                    FromDate:moment(this.filter.FromDate).locale('en').format('YYYY-MM-DD'),
                    ToDate:moment(this.filter.ToDate).locale('en').format('YYYY-MM-DD'),
                    CountIt:1
                } 
                this.$api.getRestaurant.GetRestaurantCDPList(data).then(res=>{
                    this.loadingData = false
                    this.numberOfRecords = res.listOfCDP[0].CustomerNo
                })
            },
            
            downloadList(){
                moment.locale('en');
                this.loadingData = true
                let data ={
                    RestaurantID:this.$store.state.selectedRestaurantId,
                    FromDate:moment(this.filter.FromDate).locale('en').format('YYYY-MM-DD'),
                    ToDate:moment(this.filter.ToDate).locale('en').format('YYYY-MM-DD'),
                    CountIt:0
                } 
                this.$api.getRestaurant.GetRestaurantCDPList(data).then(res=>{
                    let header = `Name,Email \n`
                    let emailFile = JSON.stringify( res.listOfCDP.map(el=>el.CustomerName + 'colonReplace' + el.CustomerEmail + ";"))
                    emailFile = emailFile.replace(/['"]+/g, '')
                    emailFile = emailFile.replace(/[,]+/g, '')
                    emailFile = emailFile.replace(/[;]+/g, '\n')
                    emailFile = emailFile.replaceAll('colonReplace', ',')
                    emailFile = emailFile.substring(1,emailFile.length - 1)
                    emailFile = header+emailFile
                    download(emailFile,"CustomerEmailList.csv", "text/plain")
                    this.loadingData = false
                })
                
            }
        },
    }
</script>

<style scoped>
    
    .sticky-footer{

        position: sticky;
        bottom: 0;
        z-index: 950;
    }
    p{
        margin: 0.3;
    }
</style>
